import { Component, HostBinding } from '@angular/core';
import { ButtonComponent } from '../core/button.component';

@Component({
  selector: 'spb-secondary-button',
  templateUrl: './secondary-button.component.html',
})
export class SecondaryButtonComponent extends ButtonComponent {
  @HostBinding('class.spb-secondary-button') hostBaseClass = true;
}
